export const environment = {
  production: false,
  apiUrl: 'https://keyo-ai.com/api' // Development ortamı için
  /* apiUrl: 'http://localhost:3030' */
}; 